import { render, staticRenderFns } from "./PolygonField.vue?vue&type=template&id=9c84ed0e&"
import script from "./PolygonField.vue?vue&type=script&lang=js&"
export * from "./PolygonField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports